<div class="d-flex flex-wrap">
    <ng-container *ngFor="let list of list; let i = index">
        <div class="cardBlock">
            <div class="h2">{{list.title}}</div>
            <div class="card-desc">{{list.description}}</div>
            <div class="mt-auto grid">
                <button class="buttonStyle" mat-raised-button color="primary"
                [disabled]="buttonClicked[i] || list.title.includes('Summary report')" 
                (click)="onButtonClick(list, i)">
                    {{buttonClicked[i] ? '' : list.buttonName}}
                    <span>
                        <mat-icon *ngIf="buttonClicked[i]">
                            <mat-spinner diameter="25"></mat-spinner>
                        </mat-icon>
                    </span>
                </button>
            </div>
        </div>
    </ng-container>
</div>